<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-1"></span></p>
<p class="Basic-Paragraph para-style-override-3">Coast Guard Heroes of New Orleans</p>
<p class="Basic-Paragraph para-style-override-4"><span class="char-style-override-2"></span></p>
<p class="Basic-Paragraph para-style-override-4"><span class="char-style-override-3"></span></p>
<p class="Basic-Paragraph para-style-override-5"></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-4"></span></p>
<p class="Basic-Paragraph para-style-override-6"></p>
<div>
<div class="Basic-Text-Frame">
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HalfTitle.vue?5e303386